// src/utils/storage.js
import { 
  getStorage, 
  ref, 
  uploadBytesResumable, 
  getDownloadURL, 
  deleteObject 
} from "firebase/storage";

/**
 * @param {File} file       업로드할 File 객체
 * @param {string} path     storage 내 폴더 경로 (예: "games/abc123")
 * @param {string} fileName 저장할 파일명 (예: "abc123_banner.png")
 * @returns {Promise<string>} 업로드된 파일의 download URL
 */
export function uploadFile(file, path, fileName) {
  const storage = getStorage();
  const storageRef = ref(storage, `${path}/${fileName}`);

  // 메타데이터에 contentType과 cacheControl을 추가
  const metadata = {
    contentType: file.type,
    cacheControl: "public, max-age=43200" // 12시간 캐시
  };

  // uploadBytesResumable에서 세 번째 인자로 metadata를 넘겨준다
  const uploadTask = uploadBytesResumable(storageRef, file, metadata);

  return new Promise((resolve, reject) => {
    uploadTask.on(
      "state_changed",
      /* 진행상황 콜백 */ snapshot => {
        // (필요 시 프로그레스 바 업데이트)
      },
      /* 에러 콜백 */ error => {
        console.error("Storage upload error:", error);
        reject(error);
      },
      /* 완료 콜백 */ async () => {
        try {
          const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
          resolve(downloadURL);
        } catch (err) {
          reject(err);
        }
      }
    );
  });
}

/**
 * @param {string} fullPath storage 레퍼런스 경로 (예: "games/abc123/1623456789_image.png")
 * @returns {Promise<void>}
 */
export async function deleteFile(fullPath) {
  const storage = getStorage();
  const storageRef = ref(storage, fullPath);
  try {
    await deleteObject(storageRef);
    console.log(`Deleted storage file: ${fullPath}`);
  } catch (err) {
    console.error(`Error deleting storage file (${fullPath}):`, err);
    throw err;
  }
}